import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

// One-time cleanup to remove any previously stored demo data
const CLEANUP_FLAG = 'initial_cleanup_done_v2';
try {
  if (!localStorage.getItem(CLEANUP_FLAG)) {
    const keysToClear = [
      'suppliers',
      'supplierOrder'
      // 'finance-store-v3' REMOVIDO: não limpar mais os dados financeiros reais
    ];
    keysToClear.forEach((k) => localStorage.removeItem(k));
    localStorage.setItem(CLEANUP_FLAG, '1');
  }
} catch (e) {
  console.warn('Falha ao limpar dados locais:', e);
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
